"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneAuthValidateCallViewContainer = void 0;
var _SourceProvider = require("../SourceProvider");
var _PhoneAuthValidateCallViewContainer = require("./PhoneAuthValidateCallViewContainer");
const PhoneAuthValidateCallViewContainer = exports.PhoneAuthValidateCallViewContainer = (0, _SourceProvider.SourceProvider)(_PhoneAuthValidateCallViewContainer.PhoneAuthValidateCallViewContainer);